module.exports = __webpack_public_path__ + "media/images/profile-151369fe49d7430efe7382383fafa629.svg";